import apiClient from './apiClient';

const URL = (process.env.REACT_APP_API_URL || 'http://localhost:4000/api') + '/tipos-de-accesos';

/**
 * Obtiene todos los tipos de accesos registrados.
 */
export const getTiposDeAccesos = async () => {
  try {
    const response = await apiClient(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
    if (response.status !== 200) {
      throw new Error(data.message || 'Error al obtener los tipos de accesos');
    }
    return data;
  } catch (error) {
    throw error;
  }
};

/**
 * Obtiene un tipo de acceso por ID.
 */
export const getTipoDeAccesoById = async (id) => {
  try {
    const response = await apiClient(`${URL}/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
    if (response.status !== 200) {
      throw new Error(data.message || `Error al obtener el tipo de acceso con ID ${id}`);
    }
    return data;
  } catch (error) {
    throw error;
  }
};
